import { useEffect, useState } from "react";

import { makeStyles } from "tss-react/mui";
import { Add } from "@mui/icons-material";
import { Box, Button, Drawer, Toolbar, Typography } from "@mui/material";
import Table from "../../components/Playoff/PlayListTable";

import { ToastContainer } from "react-toastify";

import _ from "lodash";
import { EditListDrawer } from "../../components/GrapeList/EditListDrawer";
import { useNavigate } from "react-router-dom";
import { getAllPlayoffs } from "../../apis/Playoff";
import { getCurrentUser } from "../../store/authentication/service";

const useStyles = makeStyles()((theme) => ({
  title: {
    flexGrow: 1,
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
}));

export const Playoff = ({ searchText }) => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const [editOpen, setEditOpen] = useState(false);
  const [title] = useState("Add");
  const [rows, setRows] = useState([]);
  const [seller] = useState({});
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsCount, setRowsCount] = useState(10);
  const [count, setCount] = useState(0);
  const [user, setUser] = useState();

  useEffect(() => {
    setLoading(true);
    _.debounce(async () => {
      const data = await getAllPlayoffs(rowsCount);
      console.log(data);
      setRows(data.results);
      console.log(data);
      // const cnt = await getCount(searchText, "product");
      setCount(data.count);
      // setRowsCount(data.count)
    }, 500)();
    setLoading(false);
  }, [rowsCount, searchText]);

  useEffect(() => {
    const user = getCurrentUser();
    setUser(user);
  }, []);

  const handlePage = async (_, i) => {
    const data = await getAllPlayoffs(rowsCount, i + 1);
    setRows(data.results);
    setPage(i);
  };

  const handleRowsCount = async (i) => {
    setRowsCount(i);
    setLoading(true);
    const data = await getAllPlayoffs(i);
    setRows(data.results);
    setLoading(false);
  };
  return (
    <>
      <Toolbar>
        <Typography className={classes.title} variant="h4" noWrap />
        <Button
          onClick={() => {
            if (user?.user_type === 4) {
              navigate("/upload-playoff/playoff/add");
            } else {
              navigate("/w86zjruk6q/playoff/add");
            }
          }}
          startIcon={<Add />}
          variant="contained"
          color="primary"
        >
          Add Playoff
        </Button>
      </Toolbar>
      <ToastContainer />
      <Box sx={{ px: 5 }}>
        <Table
          user={user}
          page={page}
          rowsCount={rowsCount}
          handlePage={handlePage}
          handleRowsCount={handleRowsCount}
          count={count}
          rows={rows}
          loading={loading}
          setRows={setRows}
        />
        <Drawer
          anchor="right"
          open={editOpen}
          onClose={() => setEditOpen(false)}
        >
          <EditListDrawer
            title={title}
            setEditOpen={setEditOpen}
            seller={seller}
            setRows={setRows}
          />
        </Drawer>
      </Box>
    </>
  );
};
